import { createContext, useContext, useEffect, useRef } from 'react'

// Coordinates the visit-detail page's editable sections (Appointment, Treatment,
// Clinical, Full Mouth Exam) behind a single floating "unsaved changes" save bar.
// Each section reports whether it's dirty and exposes imperative save()/cancel()
// so the page-level bar can save (or discard) everything at once.
//
// No-ops when there's no provider — sections still work standalone with their
// own inline save buttons.
export const ChartSaveContext = createContext(null)

export function useChartSave(id, dirty, save, cancel) {
  const ctx = useContext(ChartSaveContext)
  const ref = useRef({ save, cancel })
  ref.current = { save, cancel }
  // report current dirty state (+ keep the imperative handle registered)
  useEffect(() => { ctx?.report(id, dirty, ref) }, [ctx, id, dirty])
  // unregister on unmount
  useEffect(() => () => ctx?.report(id, false, null), [ctx, id])
}
